<template>
  <div class="loading-state" aria-live="polite" role="status">
    <div class="spinner" aria-hidden="true"></div>
    <p class="loading-text">{{ text }}</p>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  text?: string
}>()
</script>

<style scoped>
.loading-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3rem 1rem;
  text-align: center;
  color: rgba(11, 69, 113, 0.8);
}

.spinner {
  width: 64px;
  height: 64px;
  border: 6px solid rgba(11, 69, 113, 0.2);
  border-top-color: rgba(11, 69, 113, 0.7);
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 1.5rem;
}

.loading-text {
  font-size: 1.25rem;
  font-weight: 500;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
